
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 405 197","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#115AA5","d":"M0 0h405v197H0z"}}),_c('g',{attrs:{"opacity":".4"}},[_c('path',{attrs:{"d":"M277.195-123.352V617h129.389V-48.675l-129.389-74.677z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M212.5 100.621v516.378h129.389V25.973L212.5 100.62z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M83.11 25.973v591.026h129.388V100.621L83.109 25.973z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M212.498-48.676L83.109 25.973l129.389 74.648 129.389-74.648-129.389-74.649z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M18.389 100.623L-111 175.272l129.389 74.676 129.417-74.676-129.417-74.649z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M18.39 249.948v367.053h129.417v-441.73L18.391 249.948z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M-111 175.271v441.73H18.389V249.948L-111 175.271z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M396.584 53.37l-129.389 74.676 129.389 74.648 129.417-74.648-129.417-74.677z","fill":"#106CA4"}}),_c('path',{attrs:{"d":"M396.586 202.694v412.401h129.417v-487.05l-129.417 74.649z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M267.195 128.045v487.05h129.389V202.694l-129.389-74.649z","fill":"#7598C1"}})])])
          )
        }
      }
    